import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Button } from 'reactstrap';

import { Separator } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { postAPI_Update_VisitorSettings } from '../../../../../../constants/APIs';
import parse from 'html-react-parser'; import Validation from '../../../../../../components/Validation';
import { VisitorFormSettings } from './VisitorFormSettings';
export default function VisitorSettings({
  visitor,
  pageSettings,
  saveIntegration,
}) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [visitorData, setVisitorData] = useState(visitor);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  useEffect(() => {
    setVisitorData(visitorData);
  }, []);

  const edit = (data) => {
    setVisitorData(data);
    setIsUpdating(true);
  };
  const handleSubmit = (updateVisitorData) => {
    let setting = pageSettings;
    setting.visitorSettings = updateVisitorData;
    setVisitorData(updateVisitorData);
    setIsUpdating(false);
    saveIntegration({
      pageSettings: setting,
    });
  };
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <h6 className="text-center">Pre Chat Form</h6>
          <Separator className="mb-3" />
          <div className="text-center" style={{ marginTop: '25px' }}>
            <b>Enable</b>
            <p className="mb-2">
              {visitorData !== null &&
                visitorData.enabled !== null &&
                visitorData.enabled
                ? 'Yes'
                : 'No'}
            </p>
            <b>Title</b>
            <p className="mb-2">
              {visitorData !== null && visitorData.title
                ? visitorData.title
                : null}
            </p>
            <b>Sub Title</b>
            <p className="mb-2">
              {visitorData !== null && visitorData.subTitle
                ? parse(visitorData.subTitle)
                : null}
            </p>
            <b>Button Text</b>
            <p className="mb-2">
              {visitorData !== null && visitorData.buttonText
                ? visitorData.buttonText
                : null}
            </p>
            {/* <b>Checkbox Text</b>
            <p className="mb-2">
              {visitorData !== null
                ? parse(visitorData.checkboxText)
                : null}
            </p> */}
            <b>Fields</b>

            <p className="mb-2">
              {visitorData !== null && visitorData.fields
                ? visitorData.fields.map((elem, index) => {
                  if (visitorData.fields.length > index + 1) {
                    return elem.field + ',';
                  }
                  return elem.field;
                })
                : null}
            </p>
            <Button
              size="xs"
              color="success"
              outline
              style={{ marginTop: '3px' }}
              onClick={() => edit(visitorData)}
            >
              Edit
            </Button>
          </div>
        </CardBody>
        {isUpdating && (
          <VisitorFormSettings
            formLabel="Update Pre Chat Form"
            visible={isUpdating}
            toggle={() => {
              setIsUpdating(!isUpdating);
            }}
            submit={handleSubmit}
            visitorData={visitorData}
          />
        )}
      </Card>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
